import React from "react";

import SignupScreen from "@/screens/Authentication/SignupScreen";

export default function Main(): React.JSX.Element {
  return <SignupScreen />;
}
